module.exports = __webpack_public_path__ + "models/scene1kids.0acfc10.txt";